import type { SxProps, Theme } from "@mui/material";

export const reportItemSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: "6px",
  py: "4px",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
  cursor: "grab",
  "&:hover": {
    borderColor: "primary.main",
  },
};
